import React from 'react'
import {StripeBG, Icon} from '../../components'
import {Navbar} from '../../components/marketing'
import {DocToc} from '../../components/blog'

class Overview extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="DocPage">
        <StripeBG bg2={"white"} style="purple"/>
        <Navbar className="grid-restrain"/>
        <section className="grid-restrain grid-row full-8">
          <DocToc />
          <div className="content markdown-doc grid-item">
            <h1 className="title">Project Groups and Permissions</h1>
            <div>
              <ol>
                <li>Project permissions are found in the individual project settings page, and project groups are in the "manage projects" settings page.</li>
                <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1533096656/docs/groups%20and%20permissions/Screen_Shot_2018-07-31_at_11.10.09_PM.png" /></p>
                <li>You can set view and edit rights.  Edit encompasses creating/updating/deleting all resources within a project.  For full access, a user must be a viewer and an editor.  No permissions set means the project is public.</li>
                <p><img src="https://res.cloudinary.com/snaptest/image/upload/v1533089963/updates/1.3.2/groups.png" /></p>
                <li>If you're the orgs owner account, you'll have access to view and edit all projects in case someone accidentally locks themselves or you out of a project.</li>
              </ol>
            </div>
          </div>
        </section>
      </div>
    )
  }

}

export default Overview;



// WEBPACK FOOTER //
// ./src/pages/doc/project-groups.js